import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    vips: [],
  },
  plugins: [new VuexPersistence().plugin],
  getters: {
    vipsCount: (state) => () => {
      return(state.vips.length)
    }
  },
  mutations: {
    addvip(state, vip) {
      state.vips.push(vip);
    },
    removevip(state, vip) {
      let idx = state.vips.findIndex((f) => f == vip);
      if (idx >= 0) {
        state.vips.splice(idx, 1)
      }
    },
    editvip(state, vip) {
      let idx = state.vips.findIndex((f) => f == vip);
      if (idx >= 0) {
        state.vips.splice(idx, 1, vip)
      }
    }
  },
  actions: {
  }
});
